var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallMobileArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 330,
    viewBox: "0 0 289 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.611 5.84278L139.435 61.5848C135.44 64.4708 135.813 71.2764 140.123 74.1528L152.741 82.5705C155.932 84.7007 157.142 89.2343 155.445 92.7073L122.66 159.785C120.961 163.261 116.991 164.354 113.793 162.229L40.36 113.412C37.162 111.286 33.1901 112.379 31.4918 115.858L-56.4088 295.001C-58.1077 298.477 -56.8914 303.017 -53.6934 305.143L-26.8496 322.988C-23.6515 325.114 -19.682 324.021 -17.983 320.544L49.5259 183.18C51.2249 179.704 55.1945 178.611 58.3925 180.737L131.799 229.535C134.998 231.661 138.967 230.568 140.666 227.092L193.822 118.343C195.523 114.864 199.5 113.772 202.7 115.906L216.309 124.986C220.65 127.883 225.901 124.744 225.952 119.222L226.939 12.6474C226.995 6.65113 220.978 2.68907 216.609 5.84597L216.611 5.84278Z",
    fill: "#FDF1DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallMobileArrow);
export default __webpack_public_path__ + "static/media/install_mobile_arrow.6380a8e11fb1e50ea04495934e0a8e8a.svg";
export { ForwardRef as ReactComponent };